import { IFeed } from "types/feeds";
import { IFeedsState, IState } from "types/redux";

export const getFeedsState = ({ feeds }: IState): IFeedsState => feeds

export const getFeedItems = ({ feeds }: IState): Array<IFeed> => feeds.feeds